import { ChatPermissions, PermissionEnum } from '@thro-types/access-handler';
import { ShibUser } from '@thro-types/users';

import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router';

import PrivateRoute from 'app/components/Util/PrivateRoute';
import { translations } from 'locales/i18n';
import usePageHeading from 'utils/hooks/usePageHeading';

import { APIKeysPage } from './APIKeys/APIKeysPage';
import { ChatOverview } from './ChatOverview';

export const Chat = ({
  currentUser,
  userPermission
}: {
  currentUser: ShibUser;
  userPermission: PermissionEnum[];
}) => {
  const { t } = useTranslation();
  usePageHeading(t(translations.pages.chat.title()));

  return (
    <Routes>
      <Route
        index
        element={
          <PrivateRoute
            user={currentUser}
            userPermissions={userPermission}
            requiredPermission={ChatPermissions.AI_CHAT_READ}
          >
            <ChatOverview user={currentUser} />
          </PrivateRoute>
        }
      />
      <Route
        path="api-keys"
        element={
          <PrivateRoute
            user={currentUser}
            userPermissions={userPermission}
            requiredPermission={ChatPermissions.AI_APIKEYS_READ}
          >
            <APIKeysPage />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
